<template>
  <b-alert :show="show && getProcessTypeOptions.length > 1">
    <div class="d-flex">
      <div>
        Het geselecteerde procestype is
        <strong>{{ selectedProcessTypeLabel }}</strong>.
        U kunt uw selectie nog wijzigen totdat het proces voor de eerste keer is opgeslagen. Hierbij gaat wel alle invoer verloren.
      </div>
      <b-button
        class="ml-3"
        @click="$emit('click')"
      >
        Wijzigen
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    processType: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('tenant', [
      'getProcessTypeOptions',
      'getSelectOptionLabelByValue',
    ]),

    selectedProcessTypeLabel() {
      return this.getSelectOptionLabelByValue({
        name: 'processtypes',
        value: this.processType,
      })
    },
  },

}
</script>
